module.exports = __webpack_public_path__ + "static/img/编组 10.1e0b299a.png";